<template>

    <div class="main">

        <div>   <img alt="Vue logo" class="image-holder" src="../assets/fuldmagt.jpg" style="" /></div>

        <div class="wrapper">
            <Address v-on:submitting="submitting=true" :address="address" ref="addressForm" />
        </div>

    </div>

</template>


<script>
    import Address from "../components/Address.vue";
    export default {
        name: "Home",
        components: {
            Address

        },
        data() {
            return {
                submitting:false,
                address: {
                    firstname: "",
                    lastname: "",
                    companyname: "",
                    contactFirstname: "",
                    contactLastname: "",
                    address: "",
                    zipcode: "",
                    houseno:"",
                    floor:"",
                    door:"",
                    city: "",
                    mail: "",
                    phone: "",
                    location: "",
                    extra: "",
                    acceptSmsAdvise: false,
                    acceptConditions:false,
                    company:false,
                    addressFilled:"",
                    adresseid:""
                }
            };
        },
        methods:{
            submit(){
                this.$refs.addressForm.submit();
            }
        }
    };
</script>

<style lang="scss" scoped>
    #app {
        font-family: "NewsonGLS-Regular", Verdana, sans-serif;
    }
    .wrapper{
        border: 1px solid #FFFFFF;
        box-sizing: border-box;
        border-radius: 0px 0px 10px 10px;
        @media screen and (min-width:800px) {
            display: flex;

            justify-content: center;
            border: 1px solid #d6d6d6;
            padding: 38px;
            box-shadow: #d6d6d6 0px 0px 30px
        }
    }

    .main {
        max-width: 800px;
        width: 100%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1000px;
        .image-holder{
            border-radius: 10px 10px 0px 0px;
            width:800px;
            @media screen and (max-width: 800px) {
                width:100%;
            }
        }

        .logo {
            max-width: 200px;

            display: flex;
            flex-direction: column;
            @media screen and (max-width: 800px){
                flex-direction: row;
            }
            button{
                align-self: center;
                margin-top:auto;
                @media screen and (max-width: 800px){
                    display:none;
                }
            }

            img {
                width: 100%;
            }
            @media screen and (max-width: 1080px) {
                max-width: calc(600 / 19.2) * 1vw;
            }
            @media screen and (max-width: 800px) {
                display: flex;
                justify-content: center;
                width: 100%;
                max-width: 100%;
                img {
                    width: 50%;
                }
            }
        }
    }
</style>
